import type paper from "paper";
import type { StampMeta } from "./StampMeta";

/**
 * Scale + reposition an imported stamp SVG so its bounds map exactly to the
 * stamp's declared bbox (project units = mm). This decouples the SVG's
 * authoring viewBox from the physical stamp size — vector editors can save at
 * any convenient working size and the bbox alone determines real dimensions.
 *
 * Shared by the canvas symbol cache (`StampSymbols.parse`) and the SVG
 * exporter's `addStamp` (#945): the exporter used to skip this step, so
 * exported stamps came out at the raw viewBox size (~12× too large for the
 * bundled basket-weave) and mis-centered relative to their anchor.
 */
export function normalizeStampItemToBbox(
  item: paper.Item,
  meta: StampMeta,
  scope: paper.PaperScope,
): void {
  const b = item.bounds;
  if (!(b.width > 0) || !(b.height > 0)) return;
  const sx = meta.bbox.w / b.width;
  const sy = meta.bbox.h / b.height;
  item.scale(sx, sy, new scope.Point(0, 0));
  const after = item.bounds;
  item.translate(new scope.Point(meta.bbox.x - after.x, meta.bbox.y - after.y));
}
